import { Link, Carousel, Box, IconArrowRight16 } from '@stitch-fix/mode-react';
import {
  CloudinaryImageWrapper,
  type CloudinaryImageFields,
} from '../CloudinaryImageWrapper';
import { Header, type HeaderProps } from '../Header';
import styles from './styles.module.scss';

interface BusinessLineItem {
  linkLabel: string;
  linkHref: string;
  image: CloudinaryImageFields;
}

export interface BusinessLineCarouselProps {
  businessLines: BusinessLineItem[];
  businessLinesHeader?: HeaderProps;
}

export const BusinessLineCarousel = ({
  businessLinesHeader,
  businessLines,
}: BusinessLineCarouselProps) => {
  return (
    <Box data-testid="business-line-carousel">
      {businessLinesHeader && <Header {...businessLinesHeader} />}
      <Box className={styles.carouselContainer}>
        <Carousel ariaLabel="Business Line Carousel" slideWidth="200px">
          {businessLines.map(businessLine => (
            <Box key={businessLine.image.src} className={styles.boxContainer}>
              <Link href={businessLine.linkHref}>
                <CloudinaryImageWrapper
                  alt={businessLine.image.alt}
                  aspectRatio={businessLine.image.aspectRatio}
                  lazy
                  src={businessLine.image.src}
                  sources={{ sm: 200 }}
                  cloudinaryAsset={businessLine.image.cloudinaryAsset}
                  sizes={[{ minWidth: 0, staticWidth: 200 }]}
                  imageProps={{
                    loading: `lazy`,
                  }}
                />
              </Link>
              <Box className={styles.labelContainer}>
                <Link
                  size="cta"
                  href={businessLine.linkHref}
                  endIcon={<IconArrowRight16 purpose="decorative" />}
                >
                  {businessLine.linkLabel}
                </Link>
              </Box>
            </Box>
          ))}
        </Carousel>
      </Box>
    </Box>
  );
};
